export const SET_POINT = 'SET_POINT';

export const setPoint = data => {
  return {
    type: SET_POINT,
    data
  };
};


export const CLEAR_POINTS = 'CLEAR_POINTS';
export const clearPoints = data => {
  return {
    type: CLEAR_POINTS,
    data
  };
};

export const CLEAR_POINT = 'CLEAR_POINT';
export const clearPoint = data => {
  return {
    type: CLEAR_POINT,
    data
  };
};

export const EDIT_POINT = 'EDIT_POINT';
export const editPoint = (data) => {
  return {
    type: EDIT_POINT,
    data
  };
};

export const EDIT_POINTS_COORDS = 'EDIT_POINTS_COORDS';
export const editPointsCoords = (data) => {
  return {
    type: EDIT_POINTS_COORDS,
    data
  };
};

export const CHANGE_POINT_ORDER = 'CHANGE_POINT_ORDER';
export const changePointOrder = (data) => {
  return {
    type: CHANGE_POINT_ORDER,
    data
  };
};

export const DELETE_POINT = 'DELETE_POINT';
export const deletePoint = (data) => {
  return {
    type: DELETE_POINT,
    data
  };
};

export const UPDATE_ROUTES_DATA = 'UPDATE_ROUTES_DATA';
export const updateRoutesData = (data) => {
  return {
    type: UPDATE_ROUTES_DATA,
    data
  };
};

export const ROUTING_TOGGLE = 'ROUTING_TOGGLE';
export const routingToggle = (data) => {
  return {
    type: ROUTING_TOGGLE,
    enableState: data
  };
};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/routing/actions.js